import { makeStyles } from "@material-ui/core/styles";

// D8.20.1 — Estilos de GroupsWA.
export const useStyles = makeStyles((theme) => ({
  // ✅ CORREGIDO: MainPaper dinámico según tema
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
    borderRadius: '12px',
    boxShadow: theme.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.1)',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
  },
  
  // ✅ CORREGIDO: HeaderWrapper dinámico según tema
  headerWrapper: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
    borderRadius: 12,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    boxShadow: theme.mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
  },
  
  // ✅ CORREGIDO: SelectControl dinámico según tema
  selectControl: {
    minWidth: 300,
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#fafafa',
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiMenuItem-root": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      },
    },
  },
  
  // ✅ CORREGIDO: TableHeader dinámico según tema
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    padding: theme.spacing(1.5),
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  
  // ✅ CORREGIDO: TableRow dinámico según tema
  tableRow: {
    backgroundColor: theme.palette.background.paper,
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
    },
    '&:nth-of-type(even)': {
      backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#fafafa',
    },
    "& td": {
      color: theme.palette.text.primary,
      borderBottom: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    },
  },
  
  // ✅ CORREGIDO: TableCell dinámico según tema
  tableCell: {
    padding: theme.spacing(1.5),
    borderBottom: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    color: theme.palette.text.primary,
  },
  
  // ✅ ESTILOS DE BOTONES MEJORADOS
  buttonPrimary: {
    backgroundColor: '#1976d2',
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: theme.spacing(1, 3),
    borderRadius: 8,
    boxShadow: '0 2px 4px rgba(25, 118, 210, 0.3)',
    '&:hover': {
      backgroundColor: '#1565c0',
      boxShadow: '0 4px 8px rgba(25, 118, 210, 0.4)',
    },
    '&:disabled': {
      backgroundColor: '#cccccc',
      boxShadow: 'none',
    },
  },
  
  buttonSuccess: {
    backgroundColor: '#2e7d32',
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: theme.spacing(1, 3),
    borderRadius: 8,
    boxShadow: '0 2px 4px rgba(46, 125, 50, 0.3)',
    '&:hover': {
      backgroundColor: '#1b5e20',
      boxShadow: '0 4px 8px rgba(46, 125, 50, 0.4)',
    },
    '&:disabled': {
      backgroundColor: '#cccccc',
      boxShadow: 'none',
    },
  },
  
  actionButton: {
    padding: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.1)',
    },
  },
  
  // ✅ ESTILOS DE CHIPS MEJORADOS
  statusChip: {
    fontWeight: 'bold',
    fontSize: '0.75rem',
    padding: theme.spacing(0.5, 1),
  },
  
  adminChip: {
    backgroundColor: '#388e3c',
    color: 'white',
    boxShadow: '0 2px 4px rgba(56, 142, 60, 0.3)',
  },
  
  ownerChip: {
    backgroundColor: '#d32f2f',
    color: 'white',
    boxShadow: '0 2px 4px rgba(211, 47, 47, 0.3)',
    fontWeight: 'bold',
  },
  
  superadminChip: {
    backgroundColor: '#7b1fa2',
    color: 'white',
    boxShadow: '0 2px 4px rgba(123, 31, 162, 0.3)',
    fontWeight: 'bold',
  },
  
  userChip: {
    backgroundColor: '#616161',
    color: 'white',
    boxShadow: '0 2px 4px rgba(97, 97, 97, 0.3)',
  },
  
  newChip: {
    backgroundColor: '#ff9800',
    color: 'white',
    fontWeight: 'bold',
    boxShadow: '0 2px 4px rgba(255, 152, 0, 0.3)',
  },
  
  membersChip: {
    backgroundColor: '#2196f3',
    color: 'white',
    fontWeight: 'bold',
  },
  
  groupTypeChip: {
    backgroundColor: '#1976d2',
    color: 'white',
    fontWeight: 'bold',
    boxShadow: '0 2px 4px rgba(25, 118, 210, 0.3)',
  },
  
  communityTypeChip: {
    backgroundColor: '#9c27b0',
    color: 'white',
    fontWeight: 'bold',
    boxShadow: '0 2px 4px rgba(156, 39, 176, 0.3)',
  },
  
  // ✅ ESTILOS DE ALERTAS
  infoBox: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: '#e3f2fd',
    border: '1px solid #90caf9',
  },
  
  emptyState: {
    padding: theme.spacing(4),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  
  emptyStateIcon: {
    fontSize: 64,
    marginBottom: theme.spacing(2),
    opacity: 0.3,
  },
  
  // ✅ CORREGIDO: StatsCard dinámico según tema
  statsCard: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    boxShadow: theme.mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.05)',
    color: theme.palette.text.primary,
  },
}));
